import {Component} from "react";
import Footer from "../footer";
import React from "react";


class HSamuelFooter extends Component {

    render() {
        return (
            <div className="footer">
                <div className="footer-container">
                    <Footer model={this.props.model} isSmallSize={window.innerWidth < 760}/>
                </div>
                <div className="footer-bottom">
                    <div className="footer-container">
                        <ul style={this.styleHidden} className="social no-padding">
                            <li>
                                <a href="http://www.facebook.com/HSamuelTheJeweller"
                                   className="social-media__link social-media__link-facebook">Like us on Facebook</a>
                            </li>
                            <li>
                                <a href="http://twitter.com/hsamueljeweller"
                                   className="social-media__link social-media__link-twitter">Follow us on Twitter</a>
                            </li>
                            <li>
                                <a href="http://twitter.com/hsamueljeweller"
                                   className="social-media__link social-media__link-pinterest">Pin us on Pinterest</a>
                            </li>
                            <li>
                                <a href="http://www.youtube.com/user/HSamuelTheJewellers"
                                   className="social-media__link social-media__link-youtube">View our YouTube
                                    channel</a>
                            </li>
                            <li>
                                <a href="http://www.instagram.com/hsamueljeweller"
                                   className="social-media__link social-media__link-instagram">Browse our Instagram
                                    profile</a>
                            </li>
                            <li>
                                <a href="http://www.hsamuel.co.uk/blog/"
                                   className="social-media__link social-media__link-blog">Read our latest news on our
                                    blog</a>
                            </li>
                        </ul>
                        <small className="copyright__description">©Signet Trading Limited 2018. All rights reserved.
                            Ernest Jones and Love &amp; Life are trade marks of Signet or its licensors.
                        </small>
                    </div>
                </div>
            </div>
        )
    }
}

export default HSamuelFooter



// WEBPACK FOOTER //
// ./src/site_interfaces/footers/hsamuel.js